import React from "react";
import ProgramCreateForm from "./ProgramCreateForm";
// ----------------------------------------------------------------------
export default function TabInfoForm({ editProgram }) {
  return <ProgramCreateForm editProgram={editProgram} />;
}
